;(function () {
  angular.module('contrast.preferences').directive('tsProperty', tsProperty)

  function tsProperty($log, ErrorService, preferencesService) {
    'ngInject'

    return {
      restrict: 'A',
      scope: {
        tsPropertyValue: '='
      },
      link: link
    }

    function link(scope, element, attrs) {
      var propertyValue = scope.tsPropertyValue,
        propertyName = attrs.tsProperty || ''

      element.addClass('preference-hide')

      preferencesService.getValue(propertyName).then(
        function (preferenceValue) {
          if (propertyValue === undefined || propertyValue === null) {
            element.removeClass('preference-hide')
          } else if (preferenceValue === propertyValue.toString()) {
            element.removeClass('preference-hide')
          }
        },
        function (response) {
          $log.error(
            'Unable to retrieve TeamServer Property (' +
              propertyName +
              '): ' +
              ErrorService.getMessage(response)
          )
        }
      )
    }
  }
})()
